const locale = {
    placeholder: 'Demê hilbijêre',
    rangePlaceholder: ['Demê destpêkê', 'Demê dawiyê'],
};
export default locale;
